module.exports = __webpack_public_path__ + "static/mindwitness-8172006331d3464766fee8226205bac9.jpeg";